var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [_vm._v("User Activity")]),
        _vm._v(" "),
        _c(
          "span",
          {
            class: {
              "ring-card__header-buttons": true,
              "disable-html": _vm.loading,
            },
          },
          [
            _c("RefreshButton", {
              nativeOn: {
                click: function ($event) {
                  return _vm.getUserActivity()
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "card-content",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex justify-between items-center",
            staticStyle: { margin: "7px 0 20px 0" },
          },
          [
            _c(
              "div",
              {
                staticClass: "flex items-center justify-between filter-fields",
                attrs: { "data-info": "filters" },
              },
              [
                _c("el-date-picker", {
                  staticStyle: { "min-width": "400px" },
                  attrs: {
                    type: "datetimerange",
                    size: _vm.btnSize,
                    "picker-options": _vm.pickerOptions,
                    "default-time": ["00:00:00", "23:59:59"],
                    format: "MM/dd/yyyy HH:mm:ss",
                    "range-separator": "To",
                    "start-placeholder": "Start date",
                    "end-placeholder": "End date",
                    align: "right",
                  },
                  model: {
                    value: _vm.activityRange,
                    callback: function ($$v) {
                      _vm.activityRange = $$v
                    },
                    expression: "activityRange",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticStyle: { "max-width": "100px" },
                    attrs: { size: _vm.btnSize, placeholder: "Context" },
                    model: {
                      value: _vm.filters.context,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "context", $$v)
                      },
                      expression: "filters.context",
                    },
                  },
                  _vm._l(_vm.context, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.text, value: item.value },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    attrs: {
                      size: _vm.btnSize,
                      filterable: "",
                      clearable: "",
                      "auto-complete": "description",
                      placeholder: "Type",
                    },
                    model: {
                      value: _vm.filters.event_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "event_type", $$v)
                      },
                      expression: "filters.event_type",
                    },
                  },
                  _vm._l(_vm.eventTypes, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.text, value: item.value },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: _vm.btnSize },
                    on: {
                      click: function ($event) {
                        return _vm.getUserActivity()
                      },
                    },
                  },
                  [_vm._v("\n          Apply filters\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: _vm.btnSize },
                    on: {
                      click: function ($event) {
                        return _vm.resetFilters()
                      },
                    },
                  },
                  [_vm._v("\n          Reset\n        ")]
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            staticClass: "user-activity-table",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.userActivities },
          },
          [
            _c("el-table-column", {
              attrs: { label: "Date" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("time-zone-formatter", {
                        attrs: { "current-time": scope.row.created_at },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Context" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.context) +
                            "\n          "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Activity" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " + _vm._s(scope.row.event) + "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Agent" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.admin_user) +
                            "\n          "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Device Type" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.device_type) +
                            "\n          "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Device Name" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "Device",
                              params: { doorbot_id: scope.row.doorbot_id },
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.device_name) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "", width: 50 },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.ui_metadata
                        ? _c("MetadataPopover", {
                            attrs: { metadata: scope.row.ui_metadata },
                            on: {
                              "update:metadata": function ($event) {
                                return _vm.$set(
                                  scope.row,
                                  "ui_metadata",
                                  $event
                                )
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "user-activity-table__footer-pagination" },
          [
            _vm.error.value
              ? _c("el-alert", {
                  staticStyle: { "margin-bottom": "14px" },
                  attrs: {
                    title: _vm.error.message,
                    type: "info",
                    center: "",
                    "show-icon": "",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                layout: "total, prev, pager, next",
                "current-page": _vm.currentPage,
                "page-size": _vm.pageSize,
                total: _vm.total,
              },
              on: {
                "update:currentPage": function ($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function ($event) {
                  _vm.currentPage = $event
                },
                "current-change": _vm.onPageChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }